import React from 'react';
import HelpIcon from './HelpIcon';

const SelectInput = ({
  label,
  name,
  options,
  register,
  errors,
  validation,
  align = 'left',
  sx = {},
  showRequiredIndicator = false,
  helptext
}) => (
  <div className="form-group" style={{ textAlign: align }}>
    <label htmlFor={name}>
      {label}
      {validation?.required && showRequiredIndicator && <span className="required-indicator">*</span>}
      <HelpIcon helptext={helptext} />
    </label>
    <select
      id={name}
      style={sx}
      {...register(name, validation)}
    >
      {options.map((opt, idx) => (
        <option key={idx} value={opt.value} style={opt.sx || {}}>
          {opt.label}
        </option>
      ))}
    </select>
    {errors[name] && <p style={{ color: 'red' }}>{errors[name].message}</p>}
  </div>
);

export default SelectInput;
